import React from 'react';
import { Box, Typography } from '@mui/material';
import { capitalizeName } from '../../../../../../shared/utils';
import FormAutocomplete from '../../../../../shared/FormAutocomplete';
import CustomInputLabel from '../../../../../../layout/styledcomponents/CustomInputLabel';

type Props = {
    control: any;
    isOwner: boolean;
    beckFamilyCheck: boolean;
    visitType?: string;
};

export default function VisitTypeField({
    control,
    isOwner,
    beckFamilyCheck,
    visitType,
}: Props) {
    const locked = !isOwner && !beckFamilyCheck;

    return (
        <Box>
            <Box display='flex' gap={1} alignItems='center'>
                <CustomInputLabel>Type of Visit</CustomInputLabel>

                {locked && (
                    <Typography variant='body3' sx={{ fontSize: '11px' }}>
                        (Note: You have selected a{' '}
                        {capitalizeName(visitType || '')} experience and cannot
                        change)
                    </Typography>
                )}
            </Box>
            <FormAutocomplete
                name='bookingInfo.visitType'
                control={control}
                disabled={locked}
                options={[
                    { value: 'personal', label: 'Personal' },
                    { value: 'business', label: 'Business' },
                ]}
            />
        </Box>
    );
}
